import {
  DropdownOption,
  ExternalUserFieldAccess,
  FormField,
  GeckoSiteGrouping,
  getStringFieldByDataKey,
  InputType,
} from 'types'
import { optionalStringSchema, requiredStringSchema } from 'utils/zodHelpers'

export type GroupingInfoData = Omit<GeckoSiteGrouping, 'id'>

export const GroupingInfoFormFields = ({
  data,
  parentGroupingOptions,
}: {
  data: GroupingInfoData
  parentGroupingOptions: DropdownOption[]
}): FormField[] => {
  return [
    {
      dataKey: 'name',
      label: 'Name',
      value: data.name,
      unit_magnitude: null,
      validationRule: requiredStringSchema,
      externalUserAccess: ExternalUserFieldAccess.ReadWrite,
      isNeededForDerivedLayer: false,
      inputType: InputType.Text,
    },
    {
      dataKey: 'category',
      label: 'Category',
      value: data.category,
      unit_magnitude: null,
      validationRule: optionalStringSchema,
      externalUserAccess: ExternalUserFieldAccess.ReadWrite,
      isNeededForDerivedLayer: false,
      inputType: InputType.Text,
    },
    {
      dataKey: 'description',
      label: 'Description',
      value: data.description,
      unit_magnitude: null,
      validationRule: requiredStringSchema,
      externalUserAccess: ExternalUserFieldAccess.ReadWrite,
      isNeededForDerivedLayer: false,
      inputType: InputType.Text,
    },
    {
      dataKey: 'parent',
      label: 'Parent',
      value: data.parent,
      unit_magnitude: null,
      validationRule: optionalStringSchema,
      externalUserAccess: ExternalUserFieldAccess.ReadWrite,
      isNeededForDerivedLayer: false,
      inputType: InputType.Dropdown,
      options: parentGroupingOptions,
    },
  ]
}

export const GroupingInfoJSONFromFormFields = (
  formFields: FormField[]
): GroupingInfoData => {
  return {
    name: getStringFieldByDataKey(formFields, 'name') ?? '',
    category: getStringFieldByDataKey(formFields, 'category'),
    description: getStringFieldByDataKey(formFields, 'description') ?? '',
    parent: getStringFieldByDataKey(formFields, 'parent'),
  }
}
